// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"226a7cb1","169":"69f7f0ca","229":"a0bbc5b7","301":"dc56984b","329":"8cc92ab7","450":"7e0c6dfb","669":"6581865f","714":"b253916e","739":"98033be4","886":"67e64bad","945":"cd44d138","979":"2f44d553"}[chunkId] + ".chunk.js";
};